import jwtDecode from "jwt-decode";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLogoutQuery } from "src/api/loginAPI";
import Cookies from "universal-cookie";

const cookies = new Cookies();
export const setCookie = (name: string, value: string, option?: any) => {
  // 사파리에서 secure 안됨
  const tokenTime: any = jwtDecode(value);
  cookies.set(name, value, {
    path: "/",
    expires: new Date(tokenTime.exp * 1000),
    // secure: true,
    // sameSite: "lax",
    // httpOnly: true,
    // sameSite: "none"
  });
};

export const getCookie = (name: string) => {
  return cookies.get(name);
};

export const deleteCookie = (name: string) => {
  const tokenTime: any = jwtDecode(getCookie(name));
  cookies.remove(name, {
    path: "/",
    expires: new Date(tokenTime.exp * 1000),
    // secure: true
    // sameSite: "lax",
  });
};

export const logoutCookie = () => {
  deleteCookie("re_token");
  deleteCookie("ac_token");
  // window.location.replace("/");
};
